<template>
  <div class="mb-32">
    <RevList :has-external-borders="false">
      <RevListItemAction
        data-qa="product-technical-specifications-button"
        has-chevron
        @click="deployTechSpecModal"
      >
        <template #label>
          {{ i18n(translations.techSpec) }}
        </template>
      </RevListItemAction>
      <RevListItemAction
        data-qa="product-warranty-button"
        has-chevron
        @click="deployPerksModal"
      >
        <template #label>
          {{ i18n(translations.warranty) }}
        </template>
      </RevListItemAction>
      <RevListItemAction
        v-if="instructions"
        data-qa="product-instructions-button"
        has-chevron
        @click="deployInstructionsModal"
      >
        <template #label>
          {{ i18n(translations.instructions) }}
        </template>
      </RevListItemAction>
      <RevListItemAction
        data-qa="product-frequently-asked-questions-button"
        has-chevron
        @click="deployFaqModal"
      >
        <template #label>
          {{ i18n(translations.frequentlyAskedQuestions) }}
        </template>
      </RevListItemAction>
    </RevList>
    <TechSpecModal :technical-specifications />
    <FaqModal />
    <PerksModal :listing-id />
    <InstructionsModal v-if="instructions" :instructions :product-title />
  </div>
</template>

<script lang="ts" setup>
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { GetTechnicalSpecificationsResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/technical-specifications'
import TechSpecModal from '@backmarket/nuxt-layer-product-modals/TechSpecModal.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevList } from '@ds/components/List'
import { RevListItemAction } from '@ds/components/ListItemAction'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './AdditionalInfo.translations'
import FaqModal from './components/FaqModal/FaqModal.vue'
import InstructionsModal from './components/InstructionsModal/InstructionsModal.vue'
import PerksModal from './components/PerksModal/PerksModal.vue'

defineProps<{
  listingId: number
  productTitle: GetProductResponse['titles']['raw']
  technicalSpecifications: GetTechnicalSpecificationsResponse
  instructions: GetProductResponse['instructions']
}>()

const i18n = useI18n()

function deployTechSpecModal() {
  openModal(MODAL_NAMES.TECH_SPECS)
}

function deployFaqModal() {
  openModal(MODAL_NAMES.FAQ)
}

function deployPerksModal() {
  openModal(MODAL_NAMES.PERKS)
}

function deployInstructionsModal() {
  openModal(MODAL_NAMES.INSTRUCTIONS)
}
</script>
